import { render } from "./PlaceItemDialog.vue?vue&type=template&id=1e23765f&scoped=true"
import script from "./PlaceItemDialog.vue?vue&type=script&lang=js"
export * from "./PlaceItemDialog.vue?vue&type=script&lang=js"

import "./PlaceItemDialog.vue?vue&type=style&index=0&id=1e23765f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e23765f"]])

export default __exports__